var map = {
	"./News02.vue": [
		"3dee",
		"chunk-2d0c53e7"
	],
	"./News03.vue": [
		"c9bf",
		"chunk-094ceb90"
	],
	"./News04.vue": [
		"4e46",
		"chunk-88afb578"
	],
	"./News05.vue": [
		"f853",
		"chunk-67d9e010"
	],
	"./News06.vue": [
		"bd1e",
		"chunk-5ec792a1"
	],
	"./News07.vue": [
		"db12",
		"chunk-7080a6f4"
	],
	"./News08.vue": [
		"093a",
		"chunk-7e6c278a"
	],
	"./News09.vue": [
		"253b",
		"chunk-4b7e8ef7"
	],
	"./News10.vue": [
		"4cc1",
		"chunk-93e330aa"
	],
	"./News11.vue": [
		"bed8",
		"chunk-6af18fe5"
	],
	"./News13.vue": [
		"f0b8",
		"chunk-5ec94392"
	],
	"./News16.vue": [
		"d695",
		"chunk-2d21e7e4"
	],
	"./News17.vue": [
		"16c1",
		"chunk-927e37b2"
	],
	"./News18.vue": [
		"9ed0",
		"chunk-c354ed6c"
	],
	"./News21.vue": [
		"acf9",
		"chunk-72703b8e"
	],
	"./News22.vue": [
		"cc2f",
		"chunk-cc7798d6"
	],
	"./News24.vue": [
		"b8c8",
		"chunk-19105286"
	],
	"./News25.vue": [
		"a37d",
		"chunk-e95eb3a4"
	],
	"./News26.vue": [
		"7aaf",
		"chunk-d85c443a"
	],
	"./News28.vue": [
		"3eda",
		"chunk-7858df68"
	],
	"./News29.vue": [
		"ef79",
		"chunk-44f3f63c"
	],
	"./News30.vue": [
		"f6bb",
		"chunk-2d22d5c6"
	],
	"./News31.vue": [
		"1e4e",
		"chunk-6b908ca3"
	],
	"./News32.vue": [
		"f37b",
		"chunk-6d5473d1"
	],
	"./News33.vue": [
		"122f",
		"chunk-5184effe"
	],
	"./News34.vue": [
		"a15f",
		"chunk-552c550c"
	],
	"./News35.vue": [
		"0987",
		"chunk-fca02cd0"
	],
	"./News36.vue": [
		"f592",
		"chunk-54f94a02"
	],
	"./News37.vue": [
		"294d",
		"chunk-23565078"
	],
	"./News38.vue": [
		"ba6a",
		"chunk-dff4c2f6"
	],
	"./News39.vue": [
		"44a4",
		"chunk-3f066463"
	],
	"./News40.vue": [
		"cedf",
		"chunk-4db76db7"
	],
	"./News41.vue": [
		"4f5a",
		"chunk-835fe4a2"
	],
	"./News42.vue": [
		"2886",
		"chunk-40a37317"
	],
	"./News43.vue": [
		"8d95",
		"chunk-6fb8bd90"
	],
	"./News45.vue": [
		"a887",
		"chunk-2d20922c"
	],
	"./News47.vue": [
		"ffe7",
		"chunk-2d238a28"
	],
	"./News49.vue": [
		"1980",
		"chunk-2d0ac416"
	],
	"./News51.vue": [
		"9460",
		"chunk-2d0e540b"
	],
	"./News53.vue": [
		"14a3",
		"chunk-2d0ab64b"
	],
	"./News54.vue": [
		"58a5",
		"chunk-2d0c96cd"
	],
	"./News56.vue": [
		"f6a6",
		"chunk-2d22d57b"
	],
	"./News58.vue": [
		"7011",
		"chunk-2d0d5baf"
	],
	"./News60.vue": [
		"c8a2",
		"chunk-2d217fdc"
	],
	"./News61.vue": [
		"4b93",
		"chunk-2d0cbb3e"
	],
	"./News63.vue": [
		"c378",
		"chunk-2d216807"
	],
	"./News64.vue": [
		"6b36",
		"chunk-2d0da345"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2ea6";
module.exports = webpackAsyncContext;